import Typography from "@/components/typography/Typography"
import { useBreakpoint } from "@/hooks/useBreakpoint"
import { FC } from "react"
import "./BenefitItem.less"

const { Title, Paragraph } = Typography

import auto from "./icons/auto.png"
import saving from "./icons/cost-reduce.png"
import productivity from "./icons/numbers-up.png"
import fast from "./icons/time-saving.png"

export type BenefitPosition = "topLeft" | "bottomLeft" | "topRight" | "bottomRight" | "default"

export const benefitImages = {
  auto,
  saving,
  productivity,
  fast,
} as const

type BenefitImageKey = keyof typeof benefitImages

export type BenefitCardContent = {
  title: string
  description: string
  image: BenefitImageKey
  position?: BenefitPosition
}

const BenefitItem: FC<BenefitCardContent> = ({ title, description, image, position = "default" }) => {
  const { xxl, xl, lg, md, sm, xs } = useBreakpoint()
  const gap = xxl || xl ? "80px" : lg ? "40px" : md ? "60px" : 0

  const paddingByPosition: Record<BenefitPosition, string> = {
    topLeft: `0 ${gap} ${gap} 0`,
    bottomLeft: `${gap} ${gap} 0 0`,
    topRight: `0 0 ${gap} ${gap}`,
    bottomRight: `${gap} 0 0 ${gap}`,
    default: "0 0",
  }

  return (
    <div className={"home-benefit-item-wrapper"}>
      <div className={"padding-box"} style={{ padding: paddingByPosition[position] }}>
        <div className={"benefit-item-image"}>
          <img src={image} alt={""} />
        </div>
        <div className={"home-benefit-item-content"}>
          <Title color={"white"} level={5} style={{ paddingBottom: 8 }} centered={!md}>
            {title}
          </Title>
          <Paragraph size={!(xxl || xl || lg) ? "sm" : "md"} color={"website-secondary"} weight={"w300"} centered={!md}>
            {description}
          </Paragraph>
        </div>
      </div>
    </div>
  )
}

export default BenefitItem
